export enum Routes {
  RACINE = '',
  ANY = '**',
  COORDONNEES = 'coordonnees',
  MODIFIER_ADRESSE = 'modifier/adresse',
  MODIFIER_TELEPHONE = 'modifier/telephone',
  MODIFIER_COURRIEL = 'modifier/courriel',
  VALIDATION_COURRIEL = 'validation/courriel',
  VALIDATION_ADRESSE = 'validation/adresse',
  VALIDATION_TELEPHONE = 'validation/telephone',
  CONFIRMATION_ADRESSE = 'confirmation/adresse',
  CONFIRMATION_TELEPHONE = 'confirmation/telephone',
  CONFIRMATION_COURRIEL = 'confirmation/courriel',
  ERREUR = 'erreur',
  FIN_PARCOURS = 'fin-parcours',
}
